export type { SaveAttachmentResponse } from './attachments';
export { default as saveAttachment } from './attachments';
